import React, { useCallback, useState } from 'react';
import { Popover } from 'antd';
import { useHistory } from 'react-router-dom';
import { addProtocolToLink } from '@utils/common';
import store from '@flux/store';
import PendoIO from '@utils/pendo';
import { useDispatch } from 'react-redux';
import action from '@flux/action';
import { ModuleList } from './moduleNavigationPopover';

function getIcon(_iconId, isActive) {
  return isActive ? `icon-${_iconId}-fill` : `icon-${_iconId}-outline`;
}

const NavIconButton = ({
  index,
  isActive,
  to,
  keyName: key,
  iconId,
  displayName,
  isExternal,
  iframe,
  showPopover,
  subRoutes,
  value,
}) => {
  const { common, login } = store.getState();
  const history = useHistory();
  const dispatch = useDispatch();
  const goto = useCallback(() => {
    PendoIO.track('Project Module - Access', {
      module_name: displayName,
      project_id: common.currentId,
      uid: login.userInfo.guid,
      user_name: `${login.userInfo.given_name} ${login.userInfo.given_name}`,
    });
    if (isExternal && !iframe) {
      try {
        window.open(addProtocolToLink(to));
      } catch (e) {
        window.open('Invalid website');
      }
    } else {
      window.scrollTo(0, 0);
      history.push(to);
    }
    // TODO:10446待fix-可以考虑把这个操作放到project list的初始化的时候清空
    if (key === 'Project List') {
      dispatch(action.saveCustomizedModules([]));
    }
  }, [to]);

  const [hovered, setHovered] = useState(false);
  const close = () => setHovered(false);

  return (
    <Popover
      content={
        <ModuleList
          close={close}
          routes={subRoutes}
          projectId={common.currentId}
          history={history}
        />
      }
      placement="rightTop"
      trigger="hover"
      visible={hovered && showPopover}
      overlayClassName="module-nav-popover"
      destroyTooltipOnHide
      onVisibleChange={setHovered}
      // getPopupContainer={() =>
      //   document.querySelector(`.nav-item-${index}`) || document.body
      // }
      getPopupContainer={() => document.querySelector(`.app-sidebar-body`)}
      getTooltipContainer={() => document.querySelector(`.app-sidebar-body`)}
    >
      <div
        className={`nav-bar-item ${isActive && 'is-active'} 
        nav-item-${index}`}
        key={`sider-nav-item-${key}`}
        onClick={() => goto(to)}
      >
        <li>
          {iconId && (
            <div className="icon-wrapper">
              <span
                className={`appkiticon a-font-24 ${getIcon(iconId, isActive)}`}
              />
            </div>
          )}
          <div className={`siderbar-name ${isActive && 'is-active'}`}>
            {displayName}
          </div>
        </li>
      </div>
    </Popover>
  );
};

export default NavIconButton;
